import { render } from "./ActivateAccount.vue?vue&type=template&id=67c8bafc"
import script from "./ActivateAccount.vue?vue&type=script&lang=js"
export * from "./ActivateAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__